<template>
  <div class="design-dashboard">
    <!-- 外层 card-m（与 productioninfo 保持一致） -->
    <card-m
      class="design-info-card"
      cardWidth="100%"
      cardHeight="100%"
      maxHeight="unset"
      :show-filter="false"
    >
      <template slot="card-title">
        <AppBreadcrumb
          page-name="设计信息"
          :list="breadcrumbList"
        >
          <template #right-btn>
            <el-button
              type="primary"
              size="mini"
              @click="goToTaskProduction"
              v-if="currentWorkOrderId"
            >
              下查生产
            </el-button>
          </template>
        </AppBreadcrumb>
      </template>

      <!-- ✅ Grid 主内容区 -->
      <template slot="card-box">
        <!-- 
          ✅ 2. 整体上下 Grid 容器
          控制 main-top 和 main-bottom 的上下分布
        -->
        <div class="design-grid-container">
          
          <!-- 上半区：设计进度条 -->
          <div class="main-top">
            <card-m
              cardWidth="100%"
              cardHeight="100%"
              maxHeight="unset"
              :show-filter="false"
            >
              <template slot="card-box">
                <div class="progress-track">
                  <div class="progress_item">
                    <div class="progress_item_top">
                      <div
                        :class="progressState[0] == 0 ? 'active_item_icon' : 'item_icon'"
                      >
                    <div v-if="progressState[0] == 2 || progressState[0] == 0">1</div>
                    <i v-if="progressState[0] == 1" class="el-icon-check"> </i>
                  </div>
                  <div class="item_title">下达至设计</div>
                  <div class="item_line"></div>
                </div>
                <div class="progress_item_bottom">
                  <div>计划员：{{ designInfo.计划员 }}</div>
                  <div>接收人：{{ designInfo.接收人 }}</div>
                  <div>设计室：{{ designInfo.设计室 }}</div>
                  <div>
                    回复交期：{{
                      designInfo.回复交货期
                        ? designInfo.回复交货期.slice(0, 10)
                        : ''
                    }}
                  </div>
                  <div>
                    下达日期：{{
                      designInfo.任务下达日期 ? convertDateFormat(designInfo.任务下达日期) : ''
                    }}
                  </div>
                </div>
              </div>
              <div class="progress_item">
                <div class="progress_item_top">
                  <div
                    :class="progressState[1] == 0 ? 'active_item_icon' : 'item_icon'"
                  >
                    <div v-if="progressState[1] == 2 || progressState[1] == 0">2</div>
                    <i v-if="progressState[1] == 1" class="el-icon-check"> </i>
                  </div>
                  <div class="item_title">设计任务分配</div>
                  <div class="item_line"></div>
                </div>
                <div class="progress_item_bottom">
                  <div>下达人员：{{ designInfo.下达人员 }}</div>
                  <div>
                    下达日期：{{
                      designInfo.任务下达日期 ? convertDateFormat(designInfo.任务下达日期) : ''
                    }}
                  </div>
                  <div>主管设计：{{ designInfo.产品主管设计 }}</div>
                </div>
              </div>
              <div class="progress_item">
                <div class="progress_item_top">
                  <!-- ✅ 关键修改 -->
                  <div :class="progressState[2] == 0 ? 'active_item_icon' : 'item_icon'">
                    <div v-if="progressState[2] == 2 || progressState[2] == 0">3</div>
                    <i v-if="progressState[2] == 1" class="el-icon-check"></i>
                  </div>
                  <div class="item_title">BOM清单</div>
                  <div class="item_line"></div>
                </div>
                <div class="progress_item_bottom">
                  <div>BOM人员：{{ designInfo.BOM人员 }}</div>
                  <div>BOM总进度：{{ Math.round((designInfo.BOM进度 || 0) * 100) }}%</div>
                </div>
              </div>
              <div class="progress_item">
                <div class="progress_item_top">
                  <div
                    :class="progressState[3] == 0 ? 'active_item_icon' : 'item_icon'"
                  >
                    <div v-if="progressState[3] == 2 || progressState[3] == 0">4</div>
                    <i v-if="progressState[3] == 1" class="el-icon-check"> </i>
                  </div>
                  <div class="item_title">设计资料</div>
                  <div class="item_line"></div>
                </div>
                <div class="progress_item_bottom"></div>
              </div>
              <div class="progress_item">
                <div class="progress_item_top">
                  <div
                    :class="progressState[4] == 0 ? 'active_item_icon' : 'item_icon'"
                  >
                    <div v-if="progressState[4] == 2 || progressState[4] == 0">5</div>
                    <i v-if="progressState[4] == 1" class="el-icon-check"> </i>
                  </div>
                  <div class="item_title">检验技术要求</div>
                  <div class="item_line"></div>
                </div>
                <div class="progress_item_bottom">
                  <div>设计组长：{{ designInfo.设计组长 }}</div>
                  <div>检验人员：{{ designInfo.检验人员 }}</div>
                  <div>检验日期：{{ designInfo.检验日期 ? convertDateFormat(designInfo.检验日期) : '' }}</div>
                  <div>操作人员：{{ designInfo.操作人员 }}</div>
                </div>
              </div>
                </div>
              </template>
            </card-m>
          </div>

          <!-- 
            ✅ 3 & 4. 下半区 Grid 容器
            实现 bottom-left(左) 和 bottom-right(右) 的左右分布
            bottom-left 内部再通过 Grid 实现上下分布的 top 和 bottom
          -->
          <div class="main-bottom">
            <!-- 左侧：上下两行 -->
            <div class="bottom-left">
              <!-- <div class="bottom-left-top">
                <Allocation :contractId="contractId" ref="Allocation" />
              </div> -->
              <!-- <div class="bottom-left-bottom"> -->
                <BOMProgress :tableData="bomTableData" />
              <!-- </div> -->
            </div>

            <!-- 右侧：单行 -->
            <div class="bottom-right">
              <DetailProgress :tableData="detailTableData" />
            </div>
          </div>
        </div>
      </template>
    </card-m>
  </div>
</template>




<script>
import { getDesignInfFromTask, getDesignInfFromContract, getDesignInfFromProject } from '@/api/mainapi.js';
import { convertDateFormat } from '@/utils/tools.js';
import BOMProgress from './BOMProgress.vue';
import DetailProgress from './detailProgress.vue';
// import { set } from 'vue';

/**
 * 进度值归一化（BOM 总进度 / 资料详情完成进度 通用）
 * 兼容 0.5、50、'50%'、'已完成'、'' 等写法
 * @returns {number|null} null = 没有进度（空值或 0）；其余为 0~1 的小数
 */
function normProgress(val) {
  if (val === '' || val == null) return null;
  const s = String(val).trim();
  if (s === '') return null;
  const n = parseFloat(s.replace('%', ''));
  if (isNaN(n)) return 1;   // 非数值文案（如“已完成”）视为已有进度
  if (n <= 0) return null;  // 0 / '0%' → 没有进度
  return n > 1 ? n / 100 : n;
}

export default {
  name: 'classification',
  components: {  BOMProgress, DetailProgress },
  data() {
    return {

    designInfo: {
      下达至设计完成标志: 0,
      设计任务分配完成标志: 0,
      BOM清单完成标志: 0,
      设计资料完成标志: 0,
      检验完成标志: 0,

      计划员: '',
      接收人: '',
      设计室: '',
      项目主管设计: '',
      设计组长: '',
      检验人员: '',
      检验日期: '',

      BOM人员: '',
      BOM进度: '',

      任务下达日期: '',
      加工图规定时间: '',
      装配图规定时间: '',
      系统软件及程序规定日期: '',
      交工资料规定时间: '',
      发货清单规定时间: ''
    },
      
    // ✅ BOM 表格（只有一行）
    bomTableData: [],

    // ✅ 资料详情表格（固定 5 行）
    detailTableData: [],

    // contractId: '',
    progressState: [2, 2, 2, 2, 2], //2 未开始 0进行中 1已完成

    };
  },

  props: {
    workOrderId: {
      type: String,
      required: false,
      default: ''
    },
    contractId: {
      type: String,
      default: ''
    },
    projectName: {
      type: String,
      default: ''
    },
    parentModel: {
      type: String,
      default: ''
    }
  },

  computed: {
    /** ✅ 从路由 param 获取产品型号 */
    productModel() {
      return this.parentModel || this.$route.params.parentModel || '';
    },

    /** ✅ 从 sessionStorage 读取任务单号 */
    currentWorkOrderId() {
      return this.workOrderId
        || this.$route.params.workOrderId
        || sessionStorage.getItem('design_current_workOrderId')
        || '';
    },

    /** ✅ 从 sessionStorage 读取来源维度标记 */
    designSource() {
      return sessionStorage.getItem('design_source') || 'taskOrder';
    },

    /** ✅ 从 sessionStorage 读取合同号（面包屑链接用） */
    currentContractNo() {
      return sessionStorage.getItem('design_current_contractNo') || '';
    },

    projectNo() {
      return this.$route.params.projectNo || '';
    },

    /** ✅ 从缓存读项目名称 */
    projectNameFromCache() {
      if (!this.projectNo) return ''
      return sessionStorage.getItem(`project_name_${this.projectNo}`) || ''
    },

    /** ✅ 面包屑数据 — 完全参考 productioninfo 的逻辑 */
    breadcrumbList() {
      const list = [];

      // ✅ 首页
      if (this.designSource === 'project') {
        list.push({ label: '项目主页', to: '/homepage/projects' });
        // 项目名
        list.push({
          label: this.projectNameFromCache || this.projectNo,
          tooltip: this.projectNameFromCache || this.projectNo,
          to: `/homepage/project/${encodeURIComponent(this.projectNo)}`
        });
        // 合同名（从缓存取）
        if (this.currentContractNo) {
          list.push({
            label: this.currentContractNo,
            tooltip: this.currentContractNo,
            to: {
              name: '合同信息1',
              params: { projectNo: this.projectNo, contractId: this.currentContractNo },
              // query: { projectName: this.projectNameFromCache }
            }
          });
        }
      } else if (this.designSource === 'contract') {
        list.push({ label: '合同主页', to: '/homepage/contracts' });
        // 合同名
        list.push({
          label: this.currentContractNo,
          tooltip: this.currentContractNo,
          to: { name: '合同信息', params: { contractId: this.currentContractNo } }
        });
      } else {
        // ✅ 任务单维度
        list.push({ label: '任务单主页', to: '/homepage/workOrders' });
      }

      // ✅ 当前产品型号
      list.push({
        label: `设计：${this.productModel}`,
        tooltip: this.productModel,
        disabled: true
      });

      return list;
    },

  },    

  mounted() {
    // ✅ 设计信息：基于产品型号查询
    const contractName =  '';
    // const contractName = this.currentContractNo || '';
    const parentModel = this.productModel || '';

    if (!parentModel) {
      this.$message.warning('未获取到产品型号');
      return;
    }

    this.getDesignDetail(contractName, parentModel);
  },
  methods: {
    /** ✅ 跳转到任务单详情（生产信息页面） */
    goToTaskProduction() {
      const workOrderId = this.currentWorkOrderId;
      if (!workOrderId) {
        this.$message.warning('未获取到任务单号');
        return;
      }

      if (this.designSource === 'project') {
        // 项目维度
        this.$router.push({
          name: '任务生产信息2',
          params: {
            projectNo: this.projectNo,
            contractId: this.currentContractNo,
            workOrderId: workOrderId
          },
          query: {
            // projectName: this.projectNameFromCache
          }
        });
        this.$EventBus.$emit('currentPath',
          `/homepage/project/${encodeURIComponent(this.projectNo)}/contract/${this.currentContractNo}/production/${workOrderId}`);
      } else if (this.designSource === 'contract') {
        // 合同维度
        this.$router.push({
          name: '任务生产信息1',
          params: {
            contractId: this.currentContractNo,
            workOrderId: workOrderId
          }
        });
        this.$EventBus.$emit('currentPath',
          `/homepage/contract/${this.currentContractNo}/production/${workOrderId}`);
      } else {
        // 任务单维度
        this.$router.push({
          name: '任务生产信息',
          params: {
            workOrderId: workOrderId
          }
        });
        this.$EventBus.$emit('currentPath',
          `/homepage/workOrder/production/${workOrderId}`);
      }

      this.$EventBus.$emit('noworkOrder', true);
    },

    // ✅ 返回任务单主页（请替换为你真实的路由）
    goToTaskHome() {
      this.$router.push('/homepage/workOrders'); // ← 改成你的任务单主页路由
      this.$EventBus.$emit('currentPath', '/homepage/workOrders');
    },

    //获取设计进度
    async getDesignDetail(contractId, parentModel) {
      try {
        // ✅ 根据来源维度选择不同的接口
        let res;
        const params = {
          contractName: '',
          // contractName: contractId,
          parentModel: parentModel || ''
        };
        if (this.designSource === 'project') {
          res = await getDesignInfFromProject(params);
        } else if (this.designSource === 'contract') {
          res = await getDesignInfFromContract(params);
        } else {
          res = await getDesignInfFromTask(params);
        }

        if (res.data.code === 200) {
          const d = res.data.data;

          // ✅ 步骤状态：兼容整型(0/1/2) 和 布尔型(true/false) 两种返回格式
          // 0→进行中(蓝色)、1→已完成(勾)、2→未开始(灰色)
          const getFlag = (val) => {
            if (val === '' || val == null) return 0;
            if (val === true) return 1;
            if (val === false) return 2;
            return val;
          };

          // ✅ 步骤3/4/5：先取完成标志，步骤3 与步骤5 随后再按各自的明细进度校正
          this.progressState = [0, 0, 0, 0, 0];
          this.progressState[3] = getFlag(d.设计资料完成标志);

          // ✅ 步骤3(BOM清单)：以"BOM总进度"为准
          //   进度为 0%（或没值）→ 2 灰色未开始；0<进度<100% → 0 进行中；100% → 1 已完成
          const bomFlag = getFlag(d.BOM清单完成标志);
          const bomProgress = normProgress(d.BOM进度);
          if (bomFlag === 1 || bomProgress === 1) {
            this.progressState[2] = 1;
          } else if (bomProgress === null) {
            this.progressState[2] = 2;
          } else {
            this.progressState[2] = 0;
          }
          // ✅ 步骤5(检验技术要求)：依赖下面的"资料详情"表格，等表格生成后再判定

          // ✅ 步骤1(下达至设计) & 步骤2(设计任务分配) 优先级判断
          // 优先级1: 直接的布尔完成标志（true=已完成, false=未开始, 空=视为不存在）
          // 优先级2: 步骤1和步骤2是否开始标志 + 步骤1和步骤2完成的详细标志
          // 优先级3: 都没有 → 默认未开始
          const hasDirectFlag1 = d['下达至设计完成标志'] != null && d['下达至设计完成标志'] !== '';
          const hasDirectFlag2 = d['设计任务分配完成标志'] != null && d['设计任务分配完成标志'] !== '';

          if (hasDirectFlag1 || hasDirectFlag2) {
            // 优先级1: 直接用布尔完成标志
            this.progressState[0] = hasDirectFlag1 ? (d['下达至设计完成标志'] === true ? 1 : 2) : 2;
            this.progressState[1] = hasDirectFlag2 ? (d['设计任务分配完成标志'] === true ? 1 : 2) : 2;
          } else {
            // 优先级2: 用步骤详细标志判断
            const stepStart = d['步骤1和步骤2是否开始标志'];
            const stepDetail = d['步骤1和步骤2完成的详细标志'];

            if (stepStart === '' || stepStart == null) {
              // 优先级3: 四个字段都没有 → 默认未开始
              this.progressState[0] = 2;
              this.progressState[1] = 2;
            } else if (stepDetail === '' || stepDetail == null) {
              // 已开始但无详细标志 → 进行中
              this.progressState[0] = 0;
              this.progressState[1] = 0;
            } else if (String(stepDetail) === '1') {
              this.progressState[0] = 1;
              this.progressState[1] = 0;
            } else if (String(stepDetail) === '2') {
              this.progressState[0] = 1;
              this.progressState[1] = 1;
            } else {
              this.progressState[0] = 2;
              this.progressState[1] = 2;
            }
          }

          // ✅ 基本信息
          this.designInfo = { ...this.designInfo, ...d };

          // ✅ BOM 表格（只有一行）
          this.bomTableData = [
            {
              model: d.父项型号 || '',
              member: d.BOM人员 || '',
              progress: d.BOM进度 || '0',
              qty: d.数量 || '0',
              难度: d.项目难度系数 || '',
              // 新增三个超期天数（BOMProgress 表格最下面展示）
              首次BOM超期天数: d.首次BOM超期天数,
              外购BOM超期天数: d.外购BOM超期天数,
              完整BOM超期天数: d.完整BOM超期天数
            }
          ];

          // ✅ 日期截取辅助：只保留年月日
          const toDate = (val) => (val && typeof val === 'string' && val.length >= 10) ? val.slice(0, 10) : (val || '');

          // ✅ 资料详情表格（固定 5 行）
          // 上传时间和提交时间合并：每行只有其中一个有值
          this.detailTableData = [
            {
              类型: '加工图',
              规定时间: toDate(d.加工图规定时间),
              操作时间: toDate(d.加工图提交时间 || d.加工图上传时间),
              完成进度: d.加工图完成进度 || '',
              超期天数: d.加工图超期天数
            },
            {
              类型: '装配图',
              规定时间: toDate(d.装配图规定时间),
              操作时间: toDate(d.装配图提交时间 || d.装配图上传时间),
              完成进度: d.装配图完成进度 || '',
              超期天数: d.装配图超期天数
            },
            {
              类型: '发货清单',
              规定时间: toDate(d.发货清单规定时间),
              操作时间: toDate(d.发货清单提交时间 || d.发货清单上传时间),
              完成进度: d.发货清单完成进度 || '',
              超期天数: d.发货清单超期天数
            },
            {
              类型: '交工资料',
              规定时间: toDate(d.交工资料规定时间),
              操作时间: toDate(d.交工资料提交时间 || d.交工资料上传时间),
              完成进度: d.交工资料完成进度 || '',
              超期天数: d.交工资料超期天数
            },
            {
              类型: '系统软件',
              规定时间: toDate(d.系统软件及程序规定日期),
              操作时间: toDate(d.系统软件及程序提交时间 || d.系统软件及程序上传时间),
              完成进度: d.软件程序完成进度 || '',
              超期天数: d.系统软件及程序超期天数
            }
          ];

          // ✅ 设计资料完成标志：根据资料详情表格的操作时间自行判断
          // 全部有值→1(已完成)、部分有值→0(进行中)、全部无值→2(未开始)
          const filledCount = this.detailTableData.filter(r => r.操作时间).length;
          if (filledCount === 5) {
            this.progressState[3] = 1;
          } else if (filledCount === 0) {
            this.progressState[3] = 2;
          } else {
            this.progressState[3] = 0;
          }

          // ✅ 步骤5(检验技术要求)：依据"资料详情"里的完成进度判断
          //   全为空（或全 0）→ 2 灰色未开始；部分有进度 → 0 进行中；
          //   全部 100%（或检验完成标志明确为已完成）→ 1 已完成
          const detailProgress = this.detailTableData.map(r => normProgress(r.完成进度));
          const startedCount = detailProgress.filter(v => v !== null).length;
          const allDetailDone = startedCount === this.detailTableData.length
            && detailProgress.every(v => v >= 1);
          if (getFlag(d.检验完成标志) === 1 || allDetailDone) {
            this.progressState[4] = 1;
          } else if (startedCount === 0) {
            this.progressState[4] = 2;
          } else {
            this.progressState[4] = 0;
          }
        }
      } catch (e) {
        // console.error('获取设计信息失败', e);
      }
    },

    convertDateFormat(data) {
      return convertDateFormat(data);
    },
    // setCurrentProgress(data) {
    //   this.isFour = data;
    // }
  }
};
</script>

<style scoped lang="scss">
/* ============================================================
   布局（和 projectinfo.vue 同一套逻辑）
   ------------------------------------------------------------
   高度链：
     .main-view(homepage，height:100% + min-height:560px)
       → .design-dashboard(height:100%)
         → .card-main(外层 card-m，height:100%)
             ├─ .card-top  ← card-title（面包屑），自动高度
             └─ .card-box  ← ★ = card-main 高度 − card-title 高度
                  → .design-grid-container
                      ├─ 上方：main-top（固定高度 $top-h）
                      └─ 下方：main-bottom（吃剩余，内部左右均分）
   ------------------------------------------------------------
   想调高度只改下面这两个变量
   ============================================================ */
$top-h: 200px;         /* 上方「设计进度条」卡片的固定高度 */
$bottom-min-h: 240px;  /* 下方两张卡片的最小高度 */

/* 页面根：撑满 .main-view */
.design-dashboard {
  height: 100%;
  box-sizing: border-box;
}

/* 外层 card-m：撑满页面 + 不要边框 / 阴影（电脑 & 手机都不要） */
.design-info-card {
  height: 100% !important;
  width: 100% !important;
  border: none !important;
  box-shadow: none !important;
}

/* ⚠️★ 真正修掉「card-box 超出 main-view」的一步
   card-M 里 .card-box 写死的是 height:100%，跟上面的 .card-top(card-title) 一叠加就超出 card-main；
   更关键的是：.card-box 是 .card-main(flex 列) 的 flex 项，默认 min-height:auto
   （自动最小尺寸 = 内容的 min-content 高度），内容一高它就拒绝收缩，
   直接把 card-main / main-view 顶破 —— 这就是溢出的根因。
   三条一起改：
     flex:1 1 auto → 正好吃掉「card-main 减去 card-title」的剩余高度
     min-height:0  → 解除 flex 项「不能小于内容高度」的限制（★ 关键就是它）
     height:auto   → 别再按 100% 算，高度交给 flex 分配 */
.design-info-card ::v-deep .card-box {
  flex: 1 1 auto !important;
  height: auto !important;
  min-height: 0 !important;
  box-sizing: border-box;
}

/* ✅ 2. 整体上下分布 Grid */
.design-grid-container {
  height: 100%;
  width: 100%;
  box-sizing: border-box;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: $top-h 1fr;   /* ✅ 上方固定，下方吃剩余 */
  grid-template-areas:
    "top"
    "bottom";
  gap: 10px;
}

/* 上方：设计进度条 —— 固定高度（由 grid 第一行 $top-h 给定）
   卡片外观（背景 / 圆角 / 边框 / 阴影）由 card-M.vue 统一提供，这里不重复定义 */
.main-top {
  grid-area: top;
  position: relative;
  box-sizing: border-box;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;

  /* ✅ 内层的 card-m 撑满整个格子，卡片边框才完整包住 5 个步骤 */
  ::v-deep .card-main {
    width: 100% !important;
    height: 100% !important;
    min-width: 0 !important;
    margin-right: 0 !important;
    min-height: 0 !important;
  }

  /* ✅ 5 个步骤的容器：撑满 card-box，横向排列 */
  .progress-track {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
  }

  .progress_item {
    width: 20%;
    height: 100%;
  }
  .progress_item_top {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .active_item_icon {
      font-size: 21px;
      font-weight: 600;
      background: #1890ff;
      color: #ffffff;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 1px solid #1890ff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .item_icon {
      font-size: 21px;
      font-weight: 600;
      color: #d9d9d9;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 1px solid #d9d9d9;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-icon-check {
      color: #1890ff;
    }
    .item_title {
      width: 100px;
      font-weight: 600;
    }
    .item_line {
      height: 1px;
      background: #d9d9d9;
      width: calc(100% - 132px);
    }
  }
  .progress_item_bottom {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 45px;
    color: #8c8c8c;
    font-weight: 600;
    font-size: 14px;
    height: 70%;
    justify-content: space-evenly;
  }
}

/* ✅ 3. 下半区：吃掉剩余高度，内部左右均分 */
.main-bottom {
  grid-area: bottom;
  display: grid;
  grid-template-columns: 1fr 1fr; /* 左右均分 */
  gap: 10px;
  min-height: 0;
  min-width: 0;
  box-sizing: border-box;
}

/* ✅ 4. 下方两张卡片：平分剩余高度 + 各自一个最小高度
   ⚠️ 卡片外观（背景 / 圆角 / 边框 / 阴影）全部由 card-M.vue 统一提供，
      这里不再重复定义；max-height / overflow:hidden 也去掉，
      高度交给 grid，表格在卡片内部自己滚。 */
.bottom-left,
.bottom-right {
  min-height: $bottom-min-h;   /* ✅ 最小高度 */
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* ✅ 卡片整条链都要能收缩，表格才能在卡片内部滚，而不是把卡片撑出去
   （card-m 是 BOMProgress / DetailProgress 组件内部的，所以要 ::v-deep 才够得着） */
.bottom-left ::v-deep .card,
.bottom-right ::v-deep .card,
.bottom-left ::v-deep .card-main,
.bottom-right ::v-deep .card-main,
.bottom-left ::v-deep .card-box,
.bottom-right ::v-deep .card-box {
  flex: 1 !important;
  min-height: 0 !important;
  min-width: 0 !important;
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
}

/* ================== 进度条样式（复用原有) ================== */
.progress-wrapper {
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-around;
}

.progress_item {
  width: 18%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.progress_item_top {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .active_item_icon {
    font-size: 21px;
    font-weight: 600;
    background: #1890ff;
    color: #ffffff;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #1890ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .item_icon {
    font-size: 21px;
    font-weight: 600;
    color: #d9d9d9;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #d9d9d9;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-icon-check {
    color: #1890ff;
  }
  .item_title {
    width: 100px;
    font-weight: 600;
  }
  .item_line {
    height: 1px;
    background: #d9d9d9;
    width: calc(100% - 132px);
  }
}

.progress_item_bottom {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 45px;
  color: #8c8c8c;
  font-weight: 600;
  font-size: 14px;
  height: 70%;
  justify-content: space-evenly;
}

/* ✅ 面包屑（与 productioninfo 完全一致） */
.custom-card-title {
  display: flex;
  align-items: center;
  font-size: 20px;
  color: rgba(37, 100, 207, 0.8);
  padding-left: 20px;

  .breadcrumb-fixed {
    color: #2564cf;
    font-weight: bold;
    margin-right: 4px;
  }

  .breadcrumb-item {
    color: rgba(37, 100, 207, 0.8);
    cursor: pointer;
    font-size: 20px;

    &:hover {
      text-decoration: underline;
    }
  }

  .breadcrumb-separator {
    margin: 0 8px;
    color: rgba(105, 105, 105, 0.5);
    font-size: 20px;
  }

  .breadcrumb-item.current {
    color: #2564cf;
    cursor: default;
    font-weight: normal;

    &:hover {
      text-decoration: none;
    }
  }
}

/* ======================
   手机端：上下两行（和桌面端同一套）
   ------------------------------------------------------------
   想调手机端高度只改下面这两个变量
   ====================== */
$m-top-h: 150px;         /* 手机端「设计进度条」卡片的固定高度 */
$m-bottom-min-h: 150px;  /* 手机端下方两张卡片的最小高度 */

@media (max-width: 768px) {

  /* ✅ 和桌面端同一套：上方固定，下方吃剩余，内部两张卡上下平分
     ⚠️ 不再写死 100vh：高度改由外层 card-box 的 flex 分配决定，
        这样 card-box 才真正等于「main-view − card-title」；
        也去掉 overflow:hidden，否则会把卡片右下角的阴影裁掉。 */
  .design-grid-container {
    height: 100% !important;
    max-height: unset !important;
    min-height: 0 !important;
    grid-template-columns: 1fr !important;
    grid-template-rows: $m-top-h 1fr !important;
    gap: 8px;
    padding-bottom: 0;
  }

  /* ✅ 上半区：设计进度条 → 固定高度
     ⚠️ 滚动放在 card-box 上，不是卡片本体：
        卡片本体一滚，边框和圆角就会被一起滚出去。 */
  .main-top {
    height: 100% !important;
    min-height: 0 !important;

    ::v-deep .card-box {
      overflow-x: auto !important;   /* ✅ 关键：横向滚动 */
      overflow-y: hidden !important;
      padding: 12px 8px !important;

      /* ✅ 隐藏滚动条（防闪现） */
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none !important;
        width: 0;
        height: 0;
      }
    }
  }

  /* ✅ 进度条容器：不换行 */
  .main-top .progress-track {
    white-space: nowrap !important;
  }

  /* ✅ 进度条内部：横向排列不换行 */
  .main-top .progress_item {
    display: inline-flex !important;
    flex-direction: column !important;
    width: 160px !important;       /* 每个步骤固定宽度 */
    min-width: 160px !important;
    max-width: 160px !important;
    margin-right: 8px !important;
    vertical-align: top !important;
  }

  .main-top .progress_item_top {
    flex-shrink: 0 !important;
  }

  .main-top .progress_item_bottom {
    padding-left: 40px !important;
    font-size: 11px !important;
    line-height: 1.4 !important;
  }

  .main-top .item_title {
    width: auto !important;
    font-size: 12px !important;
    white-space: nowrap !important;
  }

  // .main-top .item_line {
  //   width: calc(100% - 180px) !important;
  // }
$m-info-h: 170px;   /* 手机端「合同信息」卡片的固定高度 */
  /* ✅ 下半区：吃掉剩余高度，内部两张卡片上下平分 */
  .main-bottom {
    height: 100% !important;
    min-height: 0 !important;
    grid-template-columns: 1fr !important;
    grid-template-rows:  $m-info-h 1fr !important;   /* ✅ 上下平分 */
    gap: 8px;
    padding-bottom: 0;
  }

  /* ✅ 下方两张卡片：平分 + 最小高度
     ⚠️ 卡片外观由 card-M.vue 提供：max-height / overflow:hidden / 圆角 / 边距全部去掉
        （整条链的 flex / min-height 规则上面已经在桌面端统一写了，这里不重复） */
  .bottom-left,
  .bottom-right {
    min-height: $m-bottom-min-h !important;
    flex: unset !important;
    max-height: unset !important;
    overflow: visible !important;
    margin: 0 !important;
  }

  /* ✅ Element Table 占满 + 内部滚动 */
  .bottom-left ::v-deep .el-table,
  .bottom-right ::v-deep .el-table {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    min-height: 0 !important;
    width: 100% !important;
  }

  .bottom-left ::v-deep .el-table__body-wrapper,
  .bottom-right ::v-deep .el-table__body-wrapper {
    flex: 1 !important;
    overflow-y: auto !important;
    min-height: 0 !important;
    width: 100% !important;
  }

  /* ✅ 表头字号收紧 */
  .bottom-left ::v-deep .el-table th,
  .bottom-right ::v-deep .el-table th {
    font-size: 11px !important;
    padding: 4px 0 !important;
  }

  .bottom-left ::v-deep .el-table td,
  .bottom-right ::v-deep .el-table td {
    font-size: 11px !important;
    padding: 3px 0 !important;
  }
}
</style>


